import { EnvironmentUrls } from 'Roblox';
import placesListModule from '../placesListModule';

const resources = {
  templateUrls: {
    placesListContainer: 'places-list-container',
    realtimePlacesListContainer: 'realtime-places-list-container',
    gameCard: 'game-card',
    gameTile: 'game-tile',
    gameIcon: 'game-icon'
  },
  modals: {
    playerInteraction: {
      templateName: 'player-interaction',
      controllerName: 'playerInteractionController'
    }
  },
  apiSets: {
    getFriendsListUrl: {
      url: EnvironmentUrls
        ? `${EnvironmentUrls.friendsApi}/v1/users/{userId}/friends`
        : '/v1/users/{userId}/friends',
      retryable: true,
      withCredentials: true
    },
    getPresences: {
      url: EnvironmentUrls
        ? `${EnvironmentUrls.presenceApi}/v1/presence/users`
        : '/v1/presence/users',
      retryable: true,
      withCredentials: true
    },
    multiGetPlaceDetails: {
      url: EnvironmentUrls
        ? `${EnvironmentUrls.gamesApi}/v1/games/multiget-place-details`
        : '/v1/games/multiget-place-details',
      retryable: true,
      withCredentials: true
    },
    multiGetGameThumbnails: {
      url: EnvironmentUrls
        ? `${EnvironmentUrls.thumbnailsApi}/v1/games/multiget/thumbnails?format=png&defaults=true`
        : '/v1/games/multiget/thumbnails?format=png&defaults=true',
      retryable: true,
      withCredentials: true
    },
    getHomeGameSorts: {
      url: EnvironmentUrls
        ? `${EnvironmentUrls.gamesApi}/v1/games/sorts`
        : '/v1/games/sorts?model.gameSortsContext=HomeSorts',
      retryable: true,
      withCredentials: true
    },
    getGamesList: {
      url: EnvironmentUrls ? `${EnvironmentUrls.gamesApi}/v1/games/list` : '/v1/games/list',
      retryable: true,
      withCredentials: true
    },
    getUnifiedGamesSort: {
      url: EnvironmentUrls
        ? `${EnvironmentUrls.gamesApi}/v1/games/sorts?model.gameSortsContext=UnifiedHomeSorts`
        : '/v1/games/sorts?model.gameSortsContext=UnifiedHomeSorts',
      retryable: true,
      withCredentials: true
    },
    enrollAbTesting: {
      url: EnvironmentUrls
        ? `${EnvironmentUrls.abtestingApiSite}/v1/enrollments`
        : '/v1/enrollments',
      retryable: false,
      withCredentials: true
    }
  },
  apiParams: {
    gameIconMultiGetLimit: 30,
    gameThumbnailsMultiGetLimit: 30,
    placeDetailsMultiGetLimit: 50,
    avatarHeadshotMultiGetLimit: 50,
    maxNumberOfGamesInRealTimePlacesList: 72,
    gameSortsContext: 'HomeSorts'
  },
  sortFiterIds: {
    MyRecent: 6,
    FriendActivity: 17,
    TopRetaining: 16,
    MyFavorite: 5
  },
  sortName: {
    MyRecent: 'MyRecent',
    MyFavorite: 'MyFavorite',
    FriendActivity: 'FriendActivity',
    TopRetaining: 'TopRetaining'
  },
  notificationNames: {
    gameFavoriteNotifications: 'GameFavoriteNotifications',
    gameCloseNotifications: 'GameCloseNotifications'
  },
  eventStreamParams: {
    goToProfileInPlacesList: {
      name: 'goToProfileInPlacesList',
      ctx: 'click'
    },
    openModalFromGameTile: {
      name: 'openModalFromGameTile',
      ctx: 'click'
    },
    goToChatInPlacesList: {
      name: 'goToChatInPlacesList',
      ctx: 'click'
    },
    joinGameInPlacesList: {
      name: 'joinGameInPlacesList',
      ctx: 'click'
    },
    goToGameDetailInPlacesList: {
      name: 'goToGameDetailInPlacesList',
      ctx: 'click'
    },
    gamePlayIntentInPlacesList: {
      ctx: 'placesListInHomePage'
    }
  },
  playersListSelector: '#interaction-container',
  cacheCriteria: {
    isEnabled: true,
    expirationMS: 30000
  }
};

placesListModule.constant('resources', resources);

export default resources;
